import TimerBanner from './TimerBanner'

export default TimerBanner
